import { avatarAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import ThemeColorConstant from "constants/ThemeColorsConstant";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style

  container: {
    // borderRadius: "0px",
    bg: ThemeColorConstant.secondaryColor,
  },
});

const ChakraUIAvatarStyling = defineMultiStyleConfig({ baseStyle });

export default ChakraUIAvatarStyling;
